import { render, staticRenderFns } from "./AssetDetails.vue?vue&type=template&id=407de267"
import script from "./AssetDetails.vue?vue&type=script&lang=js"
export * from "./AssetDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports